/**
 * Shared locale utilities for consistent locale formatting across the app.
 * Maps UI language codes to BCP 47 locale strings.
 */

// Record<string, string> statt der abgeleiteten Literal-Form: getLocale()
// nimmt bewusst JEDEN String entgegen und faengt Unbekanntes mit 'de-DE' ab.
export const LOCALE_MAP: Record<string, string> = {
  de: 'de-DE',
  en: 'en-GB',
  fr: 'fr-FR',
  es: 'es-ES',
  it: 'it-IT',
  nl: 'nl-NL',
  pl: 'pl-PL',
  sv: 'sv-SE',
  da: 'da-DK',
  no: 'nb-NO',
  pt: 'pt-PT'
};

export function getLocale(lang: string): string {
  return LOCALE_MAP[lang] || 'de-DE';
}

// Die Legal-Links (Impressum/AGB/Datenschutz/AVV) sind KEINE externen URLs
// mehr — sie leben als In-App-Routen in utils/legal.js (LEGAL_PATHS,
// Frame-Lösung via seiten/LegalPage.js).
